import { Flex, Form } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import OTPInput from "react-otp-input";
import { Link } from "react-router-dom";
import FlexCard from "../../LoanApplications/Helpers/FlexCard";
import RepaymentModal from "../Repayments/RepaymentModal";
import LoanDetailsModal from "./LoanDetailsModal";
import { useModalForm } from "../../../../../utils/hooks/useModalForm";

const Loans = (props) => {
  const BASE_URL = `${endpoints[environment].api_base}`;
  const isAdmin = props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;
  const isCollections =
    props?.$store?.persona === _enum.ROUTE_PERSONAS.collections;
  const isReadonly = props.urlparams.params.readonly === "true" ? true : false;
  const tabStatus = props.urlparams.params.status;
  const productTypeParam = props.urlparams.params.producttype;
  const frompath = props?.urlparams?.params?.frompath;
  const toastConfig = {
    autoClose: 3000,
    closeButton: false,
    hideProgressBar: true,
  };
  const [loandetails, setLoandetails] = useState({});
  const [bankdata, setBankdata] = useState({});
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [repaymentHistoryData, setRepaymentHistoryData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [rowcount, setRowcount] = useState(0);
  const amortizationColumns = [
    {
      dataIndex: "emiSequence",
      title: "Seq.",
    },
    {
      dataIndex: "emiRepaymentDate",
      title: "Payment Date",
      render: (text, record) => {
        if (record?.emiRepaymentDate) {
          let date = new Date(record?.emiRepaymentDate).dateToDDMMYYYY(
            new Date(record?.emiRepaymentDate)
          );
          return date || "-";
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "outstandingAmt",
      title: "Principal Outstanding",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "emiAmt",
      title: "EMI Amount",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "principalAmt",
      title: "Principal",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "interestAmt",
      title: "Interest",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (text, record) => {
        let status = record?.status;
        let mappedStatus = _enum.STATUS_COLOR_MAP[status?.toLowerCase()] || "";

        return (
          <Dropdown className="status-dropdown pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              {status?.toTitleCase()}
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
  ];
  const repaymentHistoryColumns = [
    {
      dataIndex: "loanAccountNumber",
      title: "LAN",
      render: (text, record) => {
        return <h6 className="text-primary">{text}</h6>;
      },
    },
    {
      dataIndex: "paymentDate",
      title: "Payment Date",
      render: (text, record) => {
        if (record?.paymentDate) {
          let date = new Date(record?.paymentDate).dateToDDMMYYYY(
            new Date(record?.paymentDate)
          );
          return date || "-";
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "paymentAmt",
      title: "Payment Amount",
      // sorter: (a, b) => a.paymentAmt - b.paymentAmt,
      render: (text, record) => {
        return <>{text?.cur()}</>;
      },
    },
    {
      dataIndex: "paymentMode",
      title: "Payment Mode",
      render: (text, record) => {
        return <>{text?.toTitleCase()}</>;
      },
    },
    {
      dataIndex: "paymentStatus",
      title: "Payment Status",
      render: (text, record) => {
        let status = record?.paymentStatus || "pending";
        let mappedStatus = _enum.STATUS_COLOR_MAP[status?.toLowerCase()] || "";

        return (
          <Dropdown className="status-dropdown pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              {status?.toTitleCase()}
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
    {
      dataIndex: "paymentReferenceNum",
      title: "Payment Ref. No.",
    },
    {
      dataIndex: "totalAmt",
      title: "Total Amount",
      render: (text, record) => {
        return <>{text?.cur()}</>;
      },
    },
    // {
    //   dataIndex: "status",
    //   title: "Txn. Status",
    //   render: (text, record) => {
    //     let status = record?.status || "pending";
    //     let mappedStatus = _enum.STATUS_COLOR_MAP[status?.toLowerCase()] || "";

    //     return (
    //       <Dropdown className="status-dropdown pe-none">
    //         <Dropdown.Toggle as="div" className={mappedStatus}>
    //           {status?.toTitleCase()}
    //         </Dropdown.Toggle>
    //       </Dropdown>
    //     );
    //   },
    // },
    {
      title: "Action",
      dataIndex: "repaymentId",
      key: "paymentReversal",
      render: (text, record) => {
        const maxRepaymentObj = repaymentHistoryData.reduce((max, current) => {
          return current.repaymentId > max.repaymentId ? current : max;
        }, repaymentHistoryData[0]);

        const maxRepaymentId = maxRepaymentObj?.repaymentId;

        // if (record.repaymentId === maxRepaymentId) {
        if (record.paymentType !== "REVERSAL") {
          return (
            <Dropdown>
              <Dropdown.Toggle
                variant="secondary"
                className="light sharp i-false"
              >
                <i className="fa fa-ellipsis-v fs-4"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  className={Object.className({
                    "dropdown-item cursor-pointer": true,
                  })}
                  onClick={() => openPaymentReversalModal(record)}
                >
                  <i class="fa-solid fa-rotate-right"></i>
                  Payment Reversal
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          );
        }
        return null;
      },
    },
  ];
  const [payinPayload, setPayinPayload] = useState(null);
  const formRef = useRef(null);
  // ----------------------------------------------------------------

  const [modalFields, setModalFields] = useState([
    {
      name: "loanAccountNumber",
      label: "Loan Application No.",
      type: "text",
      readOnly: true,
    },
    {
      name: "sanctionedLoanAmount",
      label: "Loan Amt",
      type: "text",
      readOnly: true,
    },
    {
      name: "sanctionedLoanTenure",
      label: "Tenure",
      type: "text",
      readOnly: true,
    },
    {
      name: "sanctionedLoanIRR",
      label: "ROI",
      type: "text",
      readOnly: true,
    },
    {
      name: "sanctionedLoanPF",
      label: "Processing Fee",
      type: "text",
      readOnly: true,
    },
    {
      name: "sanctionedLoanStartDate",
      label: "Loan Start date",
      type: "date",
      dateClassName: "fakedisabled",
    },
    {
      name: "sanctionedLoanEndDate",
      label: "Loan End date",
      type: "date",
      dateClassName: "fakedisabled",
    },
    {
      label: "Interest",
      name: "loanInterestAmtTillDate",
      type: "text",
      readOnly: true,
    },
    {
      label: "Penal Interest",
      name: "penaltyInterestAmtTillDate",
      type: "text",
      readOnly: true,
    },
    {
      label: "Total Payable",
      name: "totalAmountPayableAmtTillDate",
      type: "text",
      readOnly: true,
    },
    {
      label: "Amount Received",
      name: "totalRepaymentAmtTillDate",
      type: "text",
      readOnly: true,
    },
    {
      label: "Outstanding",
      name: "totalOutstandingAmtTillDate",
      type: "text",
      readOnly: true,
    },
    { label: "Overdue", name: "overdue", type: "text", readOnly: true },
    { label: "Waiver", name: "waiverAmount", type: "number", step: ".01" },
    { label: "Remarks", name: "remarks", type: "text", customcolspan: 12 },
  ]);
  const [applicationAddressInfo, setApplicationAddressInfo] = useState({});
  const [editData, setEditData] = useState([]);
  const [editmode, setEditmode] = useState(false);
  const [viewmode, setViewmode] = useState(false);
  const [openCanvas, setOpenCanvas] = useState(false);
  const [popupfields, setPopupfields] = useState({});
  const [popupdata, setPopupdata] = useState({});
  const [errorMessage, setErrorMessage] = useState({ name: "", message: "" });
  const [show, setShow] = useState(false);
  const [checkValue, setCheckValue] = useState("currentOutstanding");
  const [applicationEditdata, setApplicationEditdata] = useState({});
  const [calculatedData, setCalculatedData] = useState({});
  const [showCloseBtn, setShowCloseBtn] = useState(true);
  const [disableCloseAccountBtn, setDisableCloseAccountBtn] = useState(true);
  const [disabledWriteoffBtn, setDisabledWriteoffBtn] = useState(true);
  // ----------------------------------------------------------------

  const openLoanDetailsModal = () => {
    setOpenCanvas(true);
    addModalFields();
  };

  const closeLoanDetailsModal = () => {
    setOpenCanvas(false);
  };

  const onModalClose = (e) => {
    if (e !== undefined) {
      e.preventDefault();
    }
    closeLoanDetailsModal();
    setPopupfields({});
    setViewmode(false);
    setEditmode(false);
    setEditData({});
    setErrorMessage({ name: "", message: "" });
  };

  const addModalFields = (values) => {
    let fields = (modalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    setPopupfields(fields);
    setPopupdata(formdata);
    setOpenCanvas(true);
  };

  const editLoanDetails = (e, record) => {
    setEditmode(true);
    setViewmode(false);

    let filteredData = Object.only(
      record,
      modalFields.map((v) => v.name)
    );
    let updatedPopupData = {
      ...filteredData,
      loanInterestAmtTillDate:
        applicationEditdata?.loanInterestAmtTillDate?.toFixed(),
      totalAmountPayableAmtTillDate:
        applicationEditdata?.totalAmountPayableAmtTillDate?.toFixed(),
      amountReceived: applicationEditdata?.totalRepaymentAmtTillDate,
      penaltyInterestAmtTillDate:
        applicationEditdata?.penaltyInterestAmtTillDate?.toFixed(),
      sanctionedLoanTotalAmtPayable:
        applicationEditdata?.sanctionedLoanTotalAmtPayable,
      totalOutstandingAmtTillDate:
        applicationEditdata?.totalOutstandingAmtTillDate?.toFixed(),
      overdue: `${calculatedData?.overdueDays} days`,
      waiverAmount: applicationEditdata?.waiverAmount,
    };
    console.log({ record, filteredData, updatedPopupData });

    setPopupdata(updatedPopupData);
    setEditData(updatedPopupData);

    let updatedFields = modalFields?.map((field) => {
      if (field.type === "date") {
        return {
          ...field,
          defaultValue: dayjs(updatedPopupData[field?.name]),
        };
      }
      return {
        ...field,
        defaultValue: updatedPopupData[field?.name],
      };
    });
    setModalFields([...updatedFields]);
    openLoanDetailsModal();
  };

  useEffect(() => {
    let fields = (modalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    // console.log({ updatedfields: fields });
    setPopupfields(fields);
  }, [editData]);

  const handleSubmit = (e, data, form) => {
    e.preventDefault();
    console.log({ data });

    let payload = {
      remarks: data?.remarks,
      waiverAmount: Number(data?.waiverAmount),
    };
    console.log({ payload, editData });

    props.apis
      .apiUnderWriterGenerateAgreement(payload, {
        loanAccountNumber: data.loanAccountNumber,
      })
      .then((res) => {
        swal2.fire({
          title: "Loan Details updated successfully.",
          icon: "success",
          iconColor: "#FF4D4D",
          timer: 4000,
        });
        closeLoanDetailsModal();
        getLoanDetails();
      })
      .catch((error) => console.log(error));
  };

  const handleRunInterest = () => {
    console.log({ applicationEditdata });

    props.apis
      .apiAdminCalculateInterest({
        loanAccountNumber: props.urlparams.params.lanid,
      })
      .then((res) => {
        if (res) {
          console.log({ res });
          setCalculatedData(res?.summary);
          setLoandetails((prevstate) => {
            return {
              ...prevstate,
              interest: res?.summary?.totalNormalInterestAmt?.cur(),
              penal_interest: res?.summary?.totalPenaltyInterestAmt?.cur(),
              outstanding: res?.summary?.totalOutstandingAmount?.cur(),
              amountReceived: res?.summary?.totalRepayment?.cur(),
              totalPayable: res?.summary?.totalAmountPayable?.cur(),
              overdue: `${res?.summary?.overdueDays} days`,
              waiverAmount: res?.summary?.waiverAmount,
              closer_date: "",
            };
          });
          getLoanDetails();
        }
      });
  };

  // ----------------------------------------------------------------
  // APPLICATION PAY NOW FLOW
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [editdata, setEditdata] = useState({});
  const [checkPaymentValue, setCheckPaymentValue] =
    useState("currentOutstanding");

  const handlePaymentShow = (e) => {
    setShowPaymentModal(true);
  };

  const handlePaymentClose = (e) => {
    setShowPaymentModal(false);
  };

  const handlePaymentChange = (e) => {
    e.persist();
    let value = e.target.value;
    setCheckPaymentValue(value);
  };

  const handlePaymentSubmit = (e, data) => {
    let payload = {
      loanAccountNumber: props.urlparams.params.lanid || "",
    };

    if (checkPaymentValue === "currentOutstanding") {
      payload.amount = Number(editdata?.totalOutstandingAmtTillDate);
      if (Number(editdata?.totalOutstandingAmtTillDate) === 0) {
        swal2.fire({
          title: "Currently there's no outstanding amount",
          icon: "warning",
          iconColor: "#FF4D4D",
          timer: 4000,
        });
        return;
      }
    } else {
      payload.amount = Number(data?.amount);
    }
    console.log({ editdata, payload, data });

    const resolve = () => {
      handlePaymentClose();
      getLoanDetails();
      getApplication();
      getRepaymentHistory();
    };
    props.apis
      .apiPayinGenerateLink(payload)
      .then(async (res) => {
        if (res) {
          console.log({ res });
          await navigator.clipboard.writeText(res?.data?.payment_url);
          swal2.fire({
            title: "Payment link copied to clipboard successfully.",
            icon: "success",
            iconColor: "#FF4D4D",
            timer: 4000,
          });
          resolve();
        }
      })
      .catch((err) => {
        resolve();
      });
  };
  // ----------------------------------------------------------------
  const [showReloanModal, setShowReloanModal] = useState(false);
  const [reloanFields, setReloanFields] = useState([
    {
      name: "reLoanEligibility",
      label: "Case is eligible for Re-loan?(Y/N)",
      type: "select",
      options: _enum.YES_OR_NO_BOOLEAN,
      required: true,
    },
  ]);
  const handleReloanClose = () => setShowReloanModal(false);

  const handleReloanSubmit = (e, data) => {
    let payload = {
      reLoanEligibility: JSON.parse(data?.reLoanEligibility),
    };

    let urlData = {
      loanAccountNumber: props.urlparams.params.lanid,
    };

    console.log({ urlData, payload });

    swal2.fire({
      text: "Loan Account Closed Successfully",
      icon: "success",
      iconColor: "#FF4D4D",
      timer: 4000,
      confirmButtonText: "Close",
    });

    props.apis
      .apiAdminLoanClosureAfterRepayment(payload, urlData)
      .then((res) => {
        if (res) {
          navigate(
            `/app/loandetails?activetab=${tabStatus}&producttype=${productTypeParam}`
          );
          handleReloanClose();
        }
      });
  };

  const handleCloseAccount = () => {
    swal2
      .fire({
        title: "Are you sure want to close this loan?",
        icon: "warning",
        iconColor: "#DE3232",
        showCancelButton: true,
        confirmButtonColor: "#DE3232",
        cancelButtonColor: "##D6DBE7",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
      .then((result) => {
        if (result.isConfirmed) {
          setShowReloanModal(true);
        }
      });
  };

  const getApplication = () => {
    let payload = {
      applicationId: props.urlparams.params.id,
    };
    props.apis.apiGetCustomerApplicationById(payload).then((res) => {
      console.log({ res });

      setApplicationEditdata(res);
      setIsFetching(false);

      let payload = {
        loanAmount: res?.sanctionedLoanAmount,
        roi: res?.sanctionedLoanIRR,
        loanStartDate: res?.sanctionedLoanStartDate,
        emiStartDate: null,
        numberOfEmis: null,
        penalCharge: 0,
      };
      console.log("EMI PAYLOAD", { payload });
    });
  };

  const getLoanDetails = () => {
    props.apis
      .apiGetUnderWriterLoanApplicationDetails({
        applicationNumber: props.urlparams.params.id,
      })
      .then((res) => {
        console.log({ res });

        setEditdata(res);
        let value = res?.totalOutstandingAmtTillDate;
        if (value === null || value === "") {
          setDisableCloseAccountBtn(true);
        } else if (value <= 0) {
          setDisableCloseAccountBtn(false);
        } else {
          setDisableCloseAccountBtn(true);
        }
        setApplicationAddressInfo({
          ...Object.only(res, [
            "loanAccountNumber",
            "sanctionedLoanAmount",
            "sanctionedLoanTenure",
            "sanctionedLoanIRR",
            "sanctionedLoanPF",
            "sanctionedLoanTotalAmtPayable",
            "remarks",
            "waiverAmount",
            "amountReceived",
          ]),
          sanctionedLoanStartDate: res?.sanctionedLoanStartDate,
          sanctionedLoanEndDate: res?.sanctionedLoanEndDate,
        });
        setLoandetails((prevstate) => {
          return {
            ...prevstate,
            loan_application_no: res?.loanAccountNumber,
            loan_amt: res?.sanctionedLoanAmount?.cur(),
            tenure: res?.sanctionedLoanTenure,
            roi: res?.sanctionedLoanIRR,
            processing_fee: res?.sanctionedLoanPF?.cur(),
            loan_start_date: new Date(
              res?.sanctionedLoanStartDate
            ).dateToDDMMYYYY(new Date(res?.sanctionedLoanStartDate)),
            loan_end_date: new Date(res?.sanctionedLoanEndDate).dateToDDMMYYYY(
              new Date(res?.sanctionedLoanEndDate)
            ),
            loan_agreement: res?.loanAgreementFileId,
            interest: res.loanInterestAmtTillDate?.toFixed(),
            penal_interest: res.penaltyInterestAmtTillDate?.toFixed(),
            totalPayable: res.totalAmountPayableAmtTillDate?.toFixed(),
            amountReceived: res.totalRepaymentAmtTillDate,
            outstanding: res.totalOutstandingAmtTillDate?.toFixed(),
            overdue: prevstate.overdue,
            waiverAmount:
              res?.waiverAmount?.cur() || prevstate.waiverAmount?.cur(),
            status: res?.loanAccountStatus,
            closer_date:
              res?.loanClosingDate !== null
                ? new Date(res?.loanClosingDate).dateToDDMMYYYY(
                    new Date(res?.loanClosingDate)
                  )
                : "",
            remarks: res?.remarks,
          };
        });

        setBankdata({
          account_holder_name: res?.accountHolderName,
          account_no: res?.accountNumber,
          bank_name: res?.accountHolderBankName?.toTitleCase(),
          ifsc_code: res?.accountHolderBankIFSC,
          payment_ref_no: res?.loanAccountPayoutTnx?.[0]?.bankReferenceNumber,
          payment_date: new Date(res?.disbursementDate).dateToDDMMYYYY(
            new Date(res?.disbursementDate)
          ),
          payment_status: res?.loanAccountPayoutTnx?.[0]?.transactionStatus,
        });

        if (res?.loanAccountNumber && res?.loanAccountStatus === "CLOSED") {
          // get NOC file
          downloadNoc(res?.loanAccountNumber);
        }
        // if (res?.loanAccountNumber) {
        //   // get SOA file
        //   props.apis
        //     .apiGetCustomerSoa({
        //       loanAccountNumber: res?.loanAccountNumber,
        //     })
        //     .then((res) => {
        //       // Update the data with SOA file ID
        //       setLoandetails((prevstate) => ({
        //         ...prevstate,
        //         soa: res,
        //       }));
        //     });
        // }
      });
  };

  const downloadNoc = async (loanAccountNumber) => {
    try {
      const url = `${BASE_URL}/api/v1/accounts/noc/download/${loanAccountNumber}`;
      const authToken = props?.$store?.auth;

      const response = await axios.get(url, {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      const contentType =
        response.headers["content-type"]?.trim().toLowerCase() || "";

      // Case: Server returned a PDF
      if (contentType.includes("application/pdf")) {
        console.log({ response });

        setLoandetails((prevstate) => ({
          ...prevstate,
          noc: response?.data,
        }));
      } else {
        // Case: Server returned JSON error even with 200 status
        const text = new TextDecoder("utf-8").decode(
          new Uint8Array(response.data)
        );
        const json = JSON.parse(text);

        swal2.fire({
          title: json.message,
          icon: "error",
          iconColor: "#FF4D4D",
        });
      }
    } catch (err) {
      console.error("Failed to download NOC:", err);
      swal2.fire({
        title: "Something went wrong while fetching the NOC.",
        icon: "error",
        iconColor: "#FF4D4D",
      });
    }
  };

  useEffect(() => {
    console.log({ calculatedData, applicationEditdata });
    if (applicationEditdata?.totalOutstandingAmtTillDate <= 0) {
      setDisableCloseAccountBtn(false);
    } else {
      setDisableCloseAccountBtn(true);
    }
    appform.setFieldsValue({
      overdue: `${calculatedData?.overdueDays} Days`,
    });

    // check if loan is overdue for more than 90 days to enable write-off button
    if (calculatedData?.overdueDays > 90) {
      setDisabledWriteoffBtn(false);
    } else {
      setDisabledWriteoffBtn(true);
    }
  }, [calculatedData]);

  // ----------------------------------------------------------------
  const handleShow = (e) => {
    setShow(true);
  };

  const handleClose = (e) => {
    setShow(false);
  };

  const handlePayment = (e) => {
    e.persist();
    let value = e.target.value;
    setCheckValue(value);
  };

  const handleRepaymentSubmit = (e, data) => {
    let payload = {
      loanAccountNumber: applicationEditdata.loanAccountNumber || "",
      redirecturl: `${endpoints[environment].baseFE_URL}app/loandetails`,
    };

    if (checkValue === "currentOutstanding") {
      payload.paymentAmt = applicationEditdata.otherAmount || "";
    } else {
      payload.paymentAmt = data?.amount;
    }

    console.log({ payload });

    const resolve = () => {
      handleClose();
      getApplication();
    };

    props.apis
      .apiPayinByCustomer(payload)
      .then((res) => {
        setPayinPayload(res);
      })
      .catch((err) => {
        console.log(err);
        resolve();
      });
  };
  // ----------------------------------------------------------------
  const [repaymentEditdata, setRepaymentEditdata] = useState({});
  const [repaymentEditmode, setRepaymentEditmode] = useState(false);
  const [repaymentViewmode, setRepaymentViewmode] = useState(false);
  const [repaymentOpenCanvas, setRepaymentOpenCanvas] = useState(false);
  const [repaymentPopupfields, setRepaymentPopupfields] = useState({});
  const [repaymentPopupdata, setRepaymentPopupdata] = useState({});

  const [repaymentModalFields, setRepaymentModalFields] = useState([
    {
      name: "loanAccountNumber",
      label: "Loan Account Number",
      type: "text",
      readOnly: true,
      defaultValue: props.urlparams.params.lanid,
    },
    {
      name: "paymentDate",
      label: "Payment Date",
      type: "date",
      disabledDate: (current) => {
        return current && current > moment().startOf("day") + 1;
      },
      required: true,
    },
    {
      name: "dueDate",
      label: "Due Date",
      type: "date",
      required: true,
    },
    {
      name: "paymentAmt",
      label: "Payment Amt",
      type: "number",
      required: true,
    },
    {
      name: "lateFeeAmt",
      label: "Late Fee Amt",
      type: "number",
      required: true,
    },
    {
      name: "totalAmt",
      label: "Total Amt",
      type: "number",
      required: true,
    },
    {
      name: "paymentMode",
      label: "Payment Mode",
      type: "select",
      options: _enum.REPAYMENT_MODES,
      required: true,
    },
    {
      name: "paymentStatus",
      label: "Payment Status",
      type: "select",
      options: _enum.REPAYMENT_STATUS,
      required: true,
    },
    {
      name: "paymentReferenceNum",
      label: "Payment Reference Number",
      type: "text",
      required: true,
    },
    {
      name: "remarks",
      label: "Remarks",
      type: "textarea",
      customcolspan: 12,
    },
  ]);

  const openRepaymentModal = () => {
    setRepaymentOpenCanvas(true);
  };

  const closeRepaymentModal = () => {
    setRepaymentOpenCanvas(false);
  };

  const addRepaymentModalFields = (values) => {
    let fields = (repaymentModalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    console.log("formdata: ", fields, formdata);
    setRepaymentPopupfields(fields);
    setRepaymentPopupdata(formdata);
    setRepaymentOpenCanvas(true);
  };

  const onManualRepaymentModalClose = () => {
    console.log("onModalClose");
    closeRepaymentModal();
    setRepaymentPopupfields({});
    setRepaymentViewmode(false);
    setRepaymentEditmode(false);
    setRepaymentEditdata({});
    // setErrorMessage({ name: "", message: "" });
  };

  const viewManualRepayment = (record) => {
    // console.log({ record });
    setRepaymentEditmode(false);
    setRepaymentViewmode(true);
  };

  const editManualRepayment = (record) => {
    // console.log({ record });
    setRepaymentEditmode(true);
    setRepaymentViewmode(false);
  };

  const getRepaymentHistory = (record) => {
    let payload = {
      loanAccountNumber: props.urlparams.params.lanid,
    };
    props.apis.apiAdminGetAllLoanRepayments(payload).then((res) => {
      setRepaymentHistoryData(res);
      setIsFetching(false);
    });
  };

  const handleManualRepaymentSubmit = (e, data, form) => {
    console.log({ data });
    let payload = {
      loanAccountNumber: data?.loanAccountNumber,
      paymentDate: new Date(data.paymentDate).toISOString(),
      dueDate: new Date(data.dueDate).toISOString(),
      paymentAmt: Number(data?.paymentAmt),
      lateFeeAmt: Number(data?.lateFeeAmt),
      totalAmt: Number(data?.totalAmt),
      paymentMode: data?.paymentMode,
      paymentStatus: data?.paymentStatus,
      paymentReferenceNum: data?.paymentReferenceNum,
      remarks: data?.remarks,
    };
    console.log({ payload });

    props.apis.apiAdminAddLoanPayment(payload).then((res) => {
      console.log({ res });
      closeRepaymentModal();
      getRepaymentHistory();
    });
  };

  // ----------------   PAYMENT REVERSAL  ----------------
  const [showPaymentReversalModal, setShowPaymentReversalModal] =
    useState(false);
  const [activeRepayRecord, setActiveRepayRecord] = useState({});
  const [paymentReversalFields, setPaymentReversalFields] = useState([
    {
      name: "loanAccountNumber",
      label: "LAN",
      type: "text",
      readOnly: true,
    },
    {
      name: "paymentDate",
      label: "Payment Date",
      type: "date",
      readOnly: true,
    },
    {
      name: "paymentAmt",
      label: "Payment Amt",
      type: "number",
      readOnly: true,
    },
    {
      name: "paymentReferenceNum",
      label: "Payment Reference Number",
      type: "text",
      readOnly: true,
    },
    {
      name: "remarks",
      label: "Remarks",
      type: "textarea",
      required: true,
    },
  ]);

  const handlePaymentReversalClose = () => {
    setShowPaymentReversalModal(false);
    setActiveRepayRecord({});
  };

  const openPaymentReversalModal = (record) => {
    console.log({ record });
    setActiveRepayRecord(record);

    let updatedFields = paymentReversalFields?.map((field) => {
      if (field.type === "date") {
        return {
          ...field,
          defaultValue: dayjs(record[field?.name]),
        };
      }
      return {
        ...field,
        defaultValue: record[field?.name],
      };
    });
    setPaymentReversalFields([...updatedFields]);

    setShowPaymentReversalModal(true);
  };

  const handlePaymentReversalSubmit = (e, data) => {
    let payload = {
      repaymentId: activeRepayRecord?.repaymentId,
      remarks: data?.remarks,
    };

    console.log({ payload });

    props.apis.apiAdminReverseManualRepayment(payload).then((res) => {
      console.log({ res });

      if (res) {
        getRepaymentHistory();
        handlePaymentReversalClose();
      }
    });
  };

  useEffect(() => {
    let fields = (repaymentModalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    setRepaymentPopupfields(fields);
  }, [repaymentEditdata]);

  const getBankLink = () => {
    let link;
    if (frompath === "loandetails") {
      link = `/app/loandetails?activetab=${tabStatus}&producttype=${productTypeParam}`;
    }
    if (frompath === "dupecheck") {
      link = `/app/dupecheck`;
    }
    return link;
  };

  // ----------------------------------------------------------------
  const modalConfigs = {
    restructureLoan: [
      {
        name: "loanAccountNumber",
        label: "Loan Account Number",
        type: "text",
        readOnly: true,
        required: true,
      },
      {
        name: "outstanding",
        label: "Outstanding",
        type: "text",
        readOnly: true,
        required: true,
      },
      {
        name: "overdue",
        label: "Overdue",
        type: "text",
        readOnly: true,
      },
      {
        name: "restructureWaiver",
        label: "Waiver",
        type: "number",
        step: ".01",
        required: true,
      },
      {
        name: "sanctionedLoanAmt",
        label: "New Loan Amt",
        type: "number",
        required: true,
      },
      {
        name: "restructureIRR",
        label: "ROI",
        type: "text",
        required: true,
      },
      {
        name: "restructureTenure",
        label: "Tenure",
        type: "text",
        required: true,
      },
      {
        name: "restructureLoanStartDate",
        label: "New Loan Start Date",
        type: "date",
        disabledDate: (current) => {
          return current && current < moment().startOf("day");
        },
        // onChange: (...args) => handleRestructureLoanStartDate(...args),
        required: true,
      },
      {
        name: "restructureLoanEndDate",
        label: "New Loan End Date",
        type: "date",
        required: true,
      },
      {
        name: "restructureStatus",
        label: "Restructuring Status",
        type: "select",
        options: _enum.RESTRUCTURE_STATUS,
        readOnly: true,
      },
      {
        name: "remarks",
        label: "Remarks",
        type: "textarea",
        colspan: "24",
      },
    ],
    settlementLoan: [
      {
        name: "loanAccountNumber",
        label: "Loan Application No.",
        type: "text",
        readOnly: true,
      },
      {
        name: "sanctionedLoanAmount",
        label: "Loan Amt",
        type: "text",
        readOnly: true,
      },
      {
        name: "sanctionedLoanTenure",
        label: "Tenure",
        type: "text",
        readOnly: true,
      },
      {
        name: "sanctionedLoanStartDate",
        label: "Loan Start date",
        type: "date",
        readOnly: true,
      },
      {
        name: "sanctionedLoanEndDate",
        label: "Loan End date",
        type: "date",
        readOnly: true,
      },
      {
        label: "Total Payable",
        name: "totalAmountPayableAmtTillDate",
        type: "text",
        readOnly: true,
      },
      {
        label: "Amount Received",
        name: "totalRepaymentAmtTillDate",
        type: "text",
        readOnly: true,
      },
      {
        label: "Outstanding",
        name: "totalOutstandingAmtTillDate",
        type: "text",
        readOnly: true,
      },
      { label: "Overdue", name: "overdue", type: "text", readOnly: true },
      {
        name: "status",
        label: "Do you want to ?",
        type: "select",
        options: _enum.CLOSE_LOAN_ACCOUNT_STATUS,
        required: true,
      },
      {
        name: "writeOffAmount",
        label: "Write Off Amount",
        type: "number",
        // show this field only when status is WRITEOFF
        // showWhen: (values) => values.status === "WRITEOFF",
        required: true,
      },
      { label: "Remarks", name: "closeRemarks", type: "textarea", colspan: 24 },
    ],
  };

  const dependencies = {
    restructureTenure: (value, allValues) => {
      const startDate = allValues?.restructureLoanStartDate;
      const tenure = Number(value);

      if (dayjs.isDayjs(startDate) && !isNaN(tenure)) {
        const endDate = dayjs(startDate).add(tenure, "day");
        return { restructureLoanEndDate: endDate };
      }
    },
    restructureLoanStartDate: (value, allValues) => {
      const startDate = value;
      const tenure = Number(allValues?.restructureTenure);

      if (dayjs.isDayjs(startDate) && !isNaN(tenure)) {
        const endDate = dayjs(startDate).add(tenure, "day");
        return { restructureLoanEndDate: endDate };
      }
    },
  };

  const {
    appform,
    state: modalState,
    openModal,
    closeModal,
    handleValuesChange,
  } = useModalForm(modalConfigs, dependencies);

  // RESTRUCTURE LOAN
  const [loanRestructureData, setLoanRestructureData] = useState({});

  const openRestructureModal = () => {
    let defaultValues = {
      overdue:
        Object.keys(calculatedData).length > 0
          ? `${calculatedData?.overdueDays} Days`
          : "",
      loanAccountNumber: props.urlparams.params.lanid,
      outstanding: editdata?.totalOutstandingAmtTillDate,
      restructureWaiver: editdata?.waiverAmount,
      restructureIRR: editdata?.sanctionedLoanIRR,
      restructureTenure: editdata?.sanctionedLoanTenure,
      restructureStatus: "INITIATED",
    };
    openModal("restructureLoan", "add", "Restructure Loan", defaultValues);
  };

  // LOAN SETTLEMENT / WRITE OFF

  const openSettlementModal = () => {
    console.log({ editdata });

    let defaultValues = {
      overdue:
        Object.keys(calculatedData).length > 0
          ? `${calculatedData?.overdueDays} Days`
          : "",
      loanAccountNumber: editdata?.loanAccountNumber,
      sanctionedLoanAmount: editdata?.sanctionedLoanAmount,
      sanctionedLoanTenure: editdata?.sanctionedLoanTenure,
      sanctionedLoanStartDate: editdata?.sanctionedLoanStartDate,
      sanctionedLoanEndDate: editdata?.sanctionedLoanEndDate,
      totalAmountPayableAmtTillDate: editdata?.totalAmountPayableAmtTillDate,
      totalRepaymentAmtTillDate: editdata?.totalRepaymentAmtTillDate,
      totalOutstandingAmtTillDate: editdata?.totalOutstandingAmtTillDate,
      // overdue: editdata?.overdue,
    };
    openModal(
      "settlementLoan",
      "edit",
      "Write Off / Settlement Loan",
      defaultValues
    );
  };

  const handleAppModalSubmit = async (formData) => {
    // console.log({ modalState, formData });

    // RESTRUCTURE LOAN
    if (modalState?.type === "restructureLoan") {
      if (modalState?.mode === "add") {
        let payload = {
          ...Object.except(formData, ["overdue", "outstanding"]),
        };

        console.log({ payload });

        // save form data
        setLoanRestructureData(payload);

        // trigger general otp
        props.apis
          .apiGeneralAdminGenerateOtpVerify({
            loanAccountNumber: props.urlparams.params.lanid,
          })
          .then((res) => {
            openOTPModal();
          });
      }
    }

    // SETTLEMENT / WRITE OFF
    if (modalState?.type === "settlementLoan") {
      if (modalState?.mode === "edit") {
        let payload = {
          status: formData?.status,
          writeOffAmount: formData?.writeOffAmount?.toString(),
          closeRemarks: formData?.closeRemarks,
        };

        console.log({ payload });

        let urlData = {
          loanAccountNumber: props.urlparams.params.lanid,
        };
        props.apis
          .apiAdminLoanClosureAfterRepaymentWithStatus(payload, urlData)
          .then((res) => {
            if (res) {
              swal2.fire({
                title: "Loan write-off successfully",
                icon: "success",
                iconColor: "#FF4D4D",
                timer: 4000,
              });
              closeModal();

              navigate(
                `/app/loandetails?activetab=loansettlements&producttype=${productTypeParam}`
              );
            }
          });
      }
    }
  };
  // ----------------------------------------------------------------
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [isOtpDisabled, setIsOtpDisabled] = useState(true);

  const openOTPModal = () => {
    setShowOTPModal(true);
  };

  const closeOTPModal = () => {
    setShowOTPModal(false);
  };

  const handleOTPChange = (otp) => {
    // setOTP(otp);
    setOtpValue(otp);
    if (otp.length === 6) {
      setIsOtpDisabled(false);
    } else {
      setIsOtpDisabled(true);
    }
  };

  const handleOtpVerify = (e) => {
    let payload = {
      otpCode: otpValue,
      ...loanRestructureData,
    };
    console.log({ OTP: payload });

    // CALL RESTRUCTURE POST API
    props.apis
      .apiAddLoanRestructure(payload)
      .then((res) => {
        if (res) {
          console.log({ apiAddLoanRestructure: res });
          swal2.fire({
            title: "Loan Restructured Successfully",
            icon: "success",
            iconColor: "#FF4D4D",
            showCancelButton: false,
            timer: 3000,
          });
          setOtpValue("");
          closeOTPModal();
          getLoanDetails();
          getApplication();
        }
      })
      .catch((err) => {
        console.log(err);
        // closeOTPModal();
      });
  };

  const resendOTP = () => {
    // resend general otp
    props.apis
      .apiGeneralAdminGenerateOtpVerify({
        loanAccountNumber: props.urlparams.params.lanid,
      })
      .then((res) => {
        setOtpValue("");
        toast.success("OTP Re-Sent Successfully", toastConfig);
      });
  };
  // ----------------------------------------------------------------

  useEffect(() => {
    getLoanDetails();
    getRepaymentHistory();
  }, []);

  return (
    <>
      <div className="card p-4">
        <FlexCard
          title="Loan Details"
          data={loandetails}
          hasPdfFile={true}
          pdfIdKey="loan_agreement"
          {...(isAdmin
            ? {
                editable: isReadonly ? false : true,
                onEdit: (...args) =>
                  editLoanDetails(...args, applicationAddressInfo),
              }
            : {})}
        />
        {isAdmin && (
          <>
            <div
              className={Object.className({
                "d-none": editdata?.loanPaymentMode !== "EMI",
              })}
            >
              <Flex wrap gap="small" className="my-4">
                <div class="obligation_banner small">
                  <p class="">
                    Principal Amount Disbursed : Rs.{" "}
                    <span>{editdata?.sanctionedLoanAmount?.cur()}</span>
                  </p>
                </div>
                {/* <div class="obligation_banner small">
                  <p class="">
                    Total Interest : Rs.{" "}
                    <span>{editdata?.totalInterest?.cur()}</span>
                  </p>
                </div> */}
              </Flex>

              <AppTable
                data={
                  editdata?.emiSchedules?.sort(
                    (a, b) => a.emiSequence - b.emiSequence
                  ) || []
                }
                columns={amortizationColumns}
                total={editdata?.emiSchedules?.length || 0}
                reorder={true}
                viewable={false}
                deletable={false}
                editable={false}
              />
            </div>
            <div
              className={Object.className({
                "nav_container mt-4": true,
                "d-none": isReadonly,
              })}
            >
              <button
                type="submit"
                className="btn btn-primary me-2"
                disabled={disabledWriteoffBtn}
                onClick={(...args) => openSettlementModal(...args)}
              >
                Write Off / Settlement Loan
              </button>
              <button
                type="submit"
                className="btn btn-primary me-2"
                onClick={(...args) => openRestructureModal(...args)}
              >
                Restructure Loan
              </button>
              <button
                type="submit"
                className="btn btn-primary me-2"
                onClick={(...args) => handlePaymentShow(...args)}
              >
                Generate Payment Link
              </button>
              <button
                type="submit"
                className="btn btn-primary me-2"
                onClick={(...args) => handleRunInterest(...args)}
              >
                Run Interest
              </button>
              <button
                type="button"
                className="btn btn-primary-lite ms-2"
                onClick={(...args) => handleCloseAccount(...args)}
                disabled={disableCloseAccountBtn}
              >
                Close Account
              </button>
            </div>
          </>
        )}
        {isCollections && (
          <div
            className={Object.className({
              "nav_container mt-4": true,
            })}
          >
            <button
              type="submit"
              className="btn btn-primary me-2"
              onClick={(...args) => handlePaymentShow(...args)}
            >
              Generate Payment Link
            </button>
            <button
              type="submit"
              className="btn btn-primary me-2"
              onClick={(...args) => handleRunInterest(...args)}
            >
              Run Interest
            </button>
          </div>
        )}
      </div>
      <div className="card p-4">
        <div className="form_group_card px-0">
          <div className="d-flex align-items-start justify-content-between">
            <h2 className="mb-3 theme_text_sm">Repayment History</h2>
            {isAdmin && (
              <button
                className={Object.className({
                  "btn btn-primary mb-4": true,
                  "d-none": isReadonly,
                })}
                // onClick={(...args) => handleShow(...args)}
                onClick={(...args) => addRepaymentModalFields(...args)}
              >
                + Manual Repayments
              </button>
            )}
          </div>
          <div>
            <AppTable
              data={repaymentHistoryData}
              columns={
                isReadonly
                  ? repaymentHistoryColumns?.filter(
                      (v) => v.dataIndex !== "repaymentId"
                    )
                  : repaymentHistoryColumns
              }
              // onChange={(...arg) => onPageChange(...arg)}
              total={rowcount}
              reorder={true}
              // {...(true
              //   ? {
              //       editable: false,
              //       viewable: false,
              //     }
              //   : {
              //       editable: true,
              //       viewable: true,
              //     })}
              // viewAction={(...args) => viewManualRepayment(...args)}
              // editAction={(...args) => editManualRepayment(...args)}
              editable={false}
              viewable={false}
              deletable={false}
              loading={isFetching}
            ></AppTable>
          </div>
        </div>
      </div>
      <div className="card p-4">
        <FlexCard
          title="Bank A/C Details"
          data={bankdata}
          colspan_key="col-3"
        />
      </div>
      {isReadonly && (
        <div className="nav_container mt-5">
          <Link to={getBankLink()} className="btn btn-primary-lite me-3">
            Cancel
          </Link>
          <button
            type="button"
            className="btn btn-primary"
            onClick={(...args) => props.changeTab(...args, "personalinfo")}
          >
            Next
          </button>
        </div>
      )}
      <form
        ref={formRef}
        style={{ display: "flex", flexDirection: "column", gap: "20px" }}
        action="https://pg.icepe.in/paymentrequest"
        method="post"
        className="flex flex-col gap-4"
      >
        {payinPayload &&
          Object.keys(payinPayload).map((key) => (
            <input
              key={key}
              type="hidden"
              name={key}
              value={payinPayload[key]}
            />
          ))}
      </form>
      <Modal
        show={show}
        onHide={(...args) => handleClose(...args)}
        className="customer_application_modal payment_modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <AppForm onSubmit={handleRepaymentSubmit}>
            <div className="payment_modal_content_box">
              <p className="content_title">How much you want to pay?</p>
              <div className="checkbox_container mb-4 flex-column">
                <div class="form-check me-3">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="currentOutstanding"
                    name="communicationAddress"
                    id="currentOutstanding"
                    onChange={(...args) => handlePayment(...args)}
                    checked={checkValue === "currentOutstanding"}
                  />
                  <label class="form-check-label" for="currentOutstanding">
                    Current Outstanding
                    {applicationEditdata?.totalOutstandingAmtTillDate
                      ? ` of ${applicationEditdata?.totalOutstandingAmtTillDate?.cur()}`
                      : ""}
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="otherAmount"
                    name="communicationAddress"
                    id="otherAmount"
                    onChange={(...args) => handlePayment(...args)}
                    checked={checkValue === "otherAmount"}
                  />
                  <label class="form-check-label" for="otherAmount">
                    Other Amount
                  </label>
                </div>
              </div>
            </div>
            {checkValue === "otherAmount" && (
              <AppInput name="amount" label="Amount" type="number"></AppInput>
            )}
            <Modal.Footer className="justify-content-center">
              <button
                type="button"
                className="btn btn-primary-lite"
                onClick={(...args) => handleClose(...args)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Pay Now
              </button>
            </Modal.Footer>
          </AppForm>
        </Modal.Body>
      </Modal>
      <LoanDetailsModal
        id="employeeCanvas"
        title={`${
          editmode
            ? "Edit Loan Details"
            : viewmode
            ? "View Loan Details"
            : "Add Loan Details"
        }`}
        show={openCanvas}
        onClose={(...args) => onModalClose(...args)}
        data={popupdata}
        editdata={editData}
        fields={popupfields}
        editmode={editmode}
        onSubmit={(...args) => handleSubmit(...args)}
        submitText={`${editmode ? "Update" : "Submit"}`}
        disableallfields={viewmode ? true : false}
        errorMessage={errorMessage}
      />
      <RepaymentModal
        id="employeeCanvas"
        title={`${
          repaymentViewmode
            ? "Edit Manual Repayments"
            : viewmode
            ? "View Manual Repayments"
            : "Add Manual Repayments"
        }`}
        show={repaymentOpenCanvas}
        onClose={() => onManualRepaymentModalClose()}
        data={repaymentPopupdata}
        editdata={repaymentEditdata}
        fields={repaymentPopupfields}
        editmode={repaymentEditmode}
        onSubmit={(...args) => handleManualRepaymentSubmit(...args)}
        submitText={`${repaymentEditmode ? "Update" : "Submit"}`}
        disableallfields={repaymentViewmode ? true : false}
        // errorMessage={errorMessage}
      />
      {/* RELOAN MODAL */}
      <Modal
        show={showReloanModal}
        onHide={(...args) => handleReloanClose(...args)}
        className="customer_application_modal br-normal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Re-loan</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <AppForm onSubmit={handleReloanSubmit}>
            {reloanFields?.map((field, i) => (
              <AppInput {...field}></AppInput>
            ))}
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-primary-lite me-3"
                onClick={(...args) => handleReloanClose(...args)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </Modal.Footer>
          </AppForm>
        </Modal.Body>
      </Modal>
      {/*  */}

      <Modal
        show={showPaymentModal}
        onHide={(...args) => handlePaymentClose(...args)}
        className="customer_application_modal payment_modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <AppForm onSubmit={handlePaymentSubmit}>
            <div className="payment_modal_content_box">
              <p className="content_title">How much you want to collect?</p>
              <div className="checkbox_container mb-4 flex-column">
                <div class="form-check me-3">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="currentOutstanding"
                    name="communicationAddress"
                    id="currentOutstanding"
                    onChange={(...args) => handlePaymentChange(...args)}
                    checked={checkPaymentValue === "currentOutstanding"}
                  />
                  <label class="form-check-label" for="currentOutstanding">
                    Current Outstanding
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="otherAmount"
                    name="communicationAddress"
                    id="otherAmount"
                    onChange={(...args) => handlePaymentChange(...args)}
                    checked={checkPaymentValue === "otherAmount"}
                  />
                  <label class="form-check-label" for="otherAmount">
                    Other Amount
                  </label>
                </div>
              </div>
            </div>
            {checkPaymentValue === "otherAmount" && (
              <AppInput name="amount" label="Amount" type="number"></AppInput>
            )}
            <Modal.Footer className="justify-content-center">
              <button
                type="button"
                className="btn btn-primary-lite"
                onClick={(...args) => handlePaymentClose(...args)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Pay Now
              </button>
            </Modal.Footer>
          </AppForm>
        </Modal.Body>
      </Modal>

      {/* PAYMENT REVERSAL MODAL */}
      <Modal
        show={showPaymentReversalModal}
        onHide={(...args) => handlePaymentReversalClose(...args)}
        className="customer_application_modal br-normal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Payment Reversal</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <AppForm onSubmit={handlePaymentReversalSubmit}>
            {paymentReversalFields?.map((field, i) => (
              <AppInput {...field}></AppInput>
            ))}
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-primary-lite me-3"
                onClick={(...args) => handlePaymentReversalClose(...args)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </Modal.Footer>
          </AppForm>
        </Modal.Body>
      </Modal>

      {/* RESTRUCTURE MODAL */}

      <AppFormModal
        form={appform}
        title={modalState.title}
        open={modalState.open}
        onValuesChange={handleValuesChange}
        onClose={closeModal}
        fields={modalState.fields}
        onSubmit={handleAppModalSubmit}
        mode={modalState.mode}
      />

      {/* PAN MODAL */}
      <Modal
        show={showOTPModal}
        onHide={closeOTPModal}
        centered
        backdrop="static"
        className="consent_otp_modal"
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body className="pt-0">
          <div className="row g-3 mb-4">
            <div className="col-12 text-center">
              <h3 className="">Enter OTP</h3>
              <div className="d-flex justify-content-center">
                <OTPInput
                  value={otpValue}
                  onChange={(e) => handleOTPChange(e)}
                  separator={<span>-</span>}
                  renderInput={(props) => <input {...props} />}
                  numInputs={6}
                  shouldAutoFocus={true}
                  isInputNum={true}
                  containerStyle="otp_container small p-0"
                />
              </div>
            </div>
            <div className="col-12 text-center">
              <div className="text-center otp_bottom">
                <span className="me-2">Not received OTP?</span>
                <button
                  className="btn px-0 text-primary fs-5 border-0"
                  disabled={isOtpDisabled}
                  onClick={(e) => resendOTP(e)}
                >
                  Resend
                </button>
              </div>
            </div>
            <div className="col-12 text-center">
              <button
                type="button"
                className="btn btn-primary-lite me-3"
                onClick={(e) => closeOTPModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={(...args) => handleOtpVerify(...args)}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default constore(Loans);
